import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNotifier } from '@cbgms/base/notifier'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IConcept } from '@cbgms/api/modules/concepts'
import { generateSubmissionError } from 'utils-support/Form/SubmissionError'
import ConceptForm from './Form'
import { getConcept, updateConcept } from '../state/actions'
import useQuery, { useQueryClient } from '@cbgms/base/http/use-query'
import { Loader } from '@carsys/ui'

const FORM_NAME = 'concepts_edit'
const CACHE_KEY = 'CONCEPT_FORM'

const Edit = () => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const { conceptUUID } = useParams<{ conceptUUID: string }>()
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const { isLoading, data } = useQuery([CACHE_KEY, conceptUUID], async () => {
    const result = await dispatch(getConcept(conceptUUID))
    return result
  })

  const onSubmit = useCallback(
    async (values: IConcept) => {
      try {
        await dispatch(updateConcept(conceptUUID, values))
        return { ...values }
      } catch (error) {
        throw generateSubmissionError(error)
      }
    },
    [dispatch]
  )

  const onSubmitSuccess = useCallback(() => {
    notifier.success(t('Concepts.UpdatedSuccessfully'))
    queryClient.invalidateQueries([CACHE_KEY])
  }, [notifier, queryClient])

  if (isLoading) {
    return <Loader loading />
  }

  return (
    <ConceptForm
      form={FORM_NAME}
      initialValues={data?.Data as IConcept}
      enableReinitialize
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
    />
  )
}

export default Edit
